module.exports = __webpack_public_path__ + "assets/img/icon_logo.5300c31b.png";